export default class TischPruefenRequest {
  id: string
  tischNr: string
}
